export default "__VITE_ASSET__COl5xvEb__"